import type { Website } from "@/constants/features";

export const WEBSITE_LOCATION_SLUGS: Record<Website, readonly string[] | null> = {
  com_en: null,
  com_zh: ["c/china"],
  fr: ["c/paris"],
  de: ["c/deutschland"],
};

export function isOfferedOnWebsite(website: Website, slug: string | null): boolean {
  const allowedSlugs = WEBSITE_LOCATION_SLUGS[website];

  if (allowedSlugs === null) {
    return true;
  }

  return slug !== null && allowedSlugs.includes(slug);
}
